import { serializeHeroValues } from '@/components/forms/DesignForm/heroValues'

export function buildSeasonalDraftPreviewDesign({ defaultDesign, heroValues, selectedMedia }) {
  if (!defaultDesign) {
    return null
  }

  const previewDesign = structuredClone(defaultDesign)
  const hero = previewDesign?.pages?.['/']?.blocks?.hero?.hero?.[0]

  if (!hero) {
    return previewDesign
  }

  hero.is_enabled = true
  hero.props = {
    ...hero.props,
    ...serializeHeroValues(heroValues),
    buttonHref: '/products',
  }
  hero.media = selectedMedia ? [selectedMedia] : []

  return previewDesign
}
